import { render, staticRenderFns } from "./monitor-detail.vue?vue&type=template&id=40447786&scoped=true"
import script from "./monitor-detail.vue?vue&type=script&lang=js"
export * from "./monitor-detail.vue?vue&type=script&lang=js"
import style0 from "./monitor-detail.vue?vue&type=style&index=0&id=40447786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40447786",
  null
  
)

export default component.exports